/**
 * @generated SignedSource<<7ba393fe73671f7a40689343265b4a65>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdatePanelistInput = {
  clientMutationId?: string | null;
  data: any;
  panelistId: string;
};
export type PortalProfileComplete_UpdatePanelist_Mutation$variables = {
  input: UpdatePanelistInput;
};
export type PortalProfileComplete_UpdatePanelist_Mutation$data = {
  readonly updatePanelist: {
    readonly panelist: {
      readonly id: string;
      readonly selectedResponses: ReadonlyArray<{
        readonly answers: ReadonlyArray<{
          readonly key: string;
          readonly selected: boolean;
        }>;
        readonly characteristic: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"PortalProfileComplete_characteristic">;
        };
        readonly key: string;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"PortalProfileComplete_panelist">;
    };
  };
};
export type PortalProfileComplete_UpdatePanelist_Mutation = {
  response: PortalProfileComplete_UpdatePanelist_Mutation$data;
  variables: PortalProfileComplete_UpdatePanelist_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "SelectedResponseAnswer",
  "kind": "LinkedField",
  "name": "answers",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selected",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userSpecified",
  "storageKey": null
},
v7 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PortalProfileComplete_UpdatePanelist_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePanelistPayload",
        "kind": "LinkedField",
        "name": "updatePanelist",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PanelistNode",
            "kind": "LinkedField",
            "name": "panelist",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PortalProfileComplete_panelist"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SelectedResponse",
                "kind": "LinkedField",
                "name": "selectedResponses",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CharacteristicNode",
                    "kind": "LinkedField",
                    "name": "characteristic",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PortalProfileComplete_characteristic"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PortalProfileComplete_UpdatePanelist_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePanelistPayload",
        "kind": "LinkedField",
        "name": "updatePanelist",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PanelistNode",
            "kind": "LinkedField",
            "name": "panelist",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomPortalNode",
                "kind": "LinkedField",
                "name": "customPanelistPortal",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contactEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fadeBgBottom",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "faviconUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "footerImageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "headerMarkup",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "headerMarkupEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "heroAssetUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "heroBackgroundUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hidePanelistProfile",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pageTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "privacyPolicyUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "termsLabel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "termsUrl",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SelectedResponse",
                "kind": "LinkedField",
                "name": "selectedResponses",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CharacteristicNode",
                    "kind": "LinkedField",
                    "name": "characteristic",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CharacteristicResponseNodeConnection",
                        "kind": "LinkedField",
                        "name": "responses",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicResponseNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CharacteristicResponseNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CharacteristicAnswerNode",
                                    "kind": "LinkedField",
                                    "name": "answer",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "customAnswer",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PanelistNode",
                                    "kind": "LinkedField",
                                    "name": "panelist",
                                    "plural": false,
                                    "selections": (v7/*: any*/),
                                    "storageKey": null
                                  },
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "textValue",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CharacteristicRowNode",
                                    "kind": "LinkedField",
                                    "name": "row",
                                    "plural": false,
                                    "selections": (v7/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CharacteristicElementMetaNode",
                        "kind": "LinkedField",
                        "name": "elementMeta",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "responseValidation",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "target",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "target2",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CharacteristicAnswerNode",
                        "kind": "LinkedField",
                        "name": "answers",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CharacteristicRowNode",
                        "kind": "LinkedField",
                        "name": "rows",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "840986f5c082ca9eb3400da7c650515e",
    "id": null,
    "metadata": {},
    "name": "PortalProfileComplete_UpdatePanelist_Mutation",
    "operationKind": "mutation",
    "text": "mutation PortalProfileComplete_UpdatePanelist_Mutation(\n  $input: UpdatePanelistInput!\n) {\n  updatePanelist(input: $input) {\n    panelist {\n      id\n      ...PortalProfileComplete_panelist\n      selectedResponses {\n        key\n        answers {\n          key\n          selected\n        }\n        characteristic {\n          id\n          ...PortalProfileComplete_characteristic\n        }\n      }\n    }\n  }\n}\n\nfragment FormItemCharacteristicResponses_characteristic on CharacteristicNode {\n  id\n  elementMeta {\n    responseValidation\n    target\n    target2\n  }\n  text\n  type\n  ...InputCharacteristicResponses_characteristic\n}\n\nfragment FormItemCharacteristicResponses_characteristicResponses on CharacteristicResponseNode {\n  ...InputCharacteristicResponses_characteristicResponses\n  answer {\n    id\n  }\n  customAnswer\n}\n\nfragment InputCharacteristicResponseDate_characteristic on CharacteristicNode {\n  id\n}\n\nfragment InputCharacteristicResponseDate_characteristicResponses on CharacteristicResponseNode {\n  id\n  textValue\n}\n\nfragment InputCharacteristicResponseGridSingleSelect_characteristic on CharacteristicNode {\n  id\n  answers {\n    id\n    text\n  }\n  rows {\n    id\n    text\n  }\n}\n\nfragment InputCharacteristicResponseGridSingleSelect_characteristicResponses on CharacteristicResponseNode {\n  id\n  answer {\n    id\n  }\n  row {\n    id\n  }\n}\n\nfragment InputCharacteristicResponseMultiSelect_characteristic on CharacteristicNode {\n  id\n  answers {\n    id\n    text\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponseMultiSelect_characteristicResponses on CharacteristicResponseNode {\n  id\n  customAnswer\n  answer {\n    id\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponseNumber_characteristic on CharacteristicNode {\n  id\n  elementMeta {\n    responseValidation\n    target\n    target2\n  }\n}\n\nfragment InputCharacteristicResponseNumber_characteristicResponses on CharacteristicResponseNode {\n  id\n  textValue\n}\n\nfragment InputCharacteristicResponseOpenEnd_characteristic on CharacteristicNode {\n  id\n}\n\nfragment InputCharacteristicResponseOpenEnd_characteristicResponses on CharacteristicResponseNode {\n  id\n  textValue\n}\n\nfragment InputCharacteristicResponseSingleSelect_characteristic on CharacteristicNode {\n  id\n  answers {\n    id\n    text\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponseSingleSelect_characteristicResponses on CharacteristicResponseNode {\n  id\n  customAnswer\n  answer {\n    id\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponses_characteristic on CharacteristicNode {\n  type\n  ...InputCharacteristicResponseDate_characteristic\n  ...InputCharacteristicResponseGridSingleSelect_characteristic\n  ...InputCharacteristicResponseMultiSelect_characteristic\n  ...InputCharacteristicResponseNumber_characteristic\n  ...InputCharacteristicResponseOpenEnd_characteristic\n  ...InputCharacteristicResponseSingleSelect_characteristic\n}\n\nfragment InputCharacteristicResponses_characteristicResponses on CharacteristicResponseNode {\n  ...InputCharacteristicResponseDate_characteristicResponses\n  ...InputCharacteristicResponseGridSingleSelect_characteristicResponses\n  ...InputCharacteristicResponseMultiSelect_characteristicResponses\n  ...InputCharacteristicResponseNumber_characteristicResponses\n  ...InputCharacteristicResponseOpenEnd_characteristicResponses\n  ...InputCharacteristicResponseSingleSelect_characteristicResponses\n}\n\nfragment PortalProfileComplete_characteristic on CharacteristicNode {\n  id\n  type\n  text\n  responses {\n    edges {\n      node {\n        answer {\n          id\n          userSpecified\n        }\n        customAnswer\n        panelist {\n          id\n        }\n        ...FormItemCharacteristicResponses_characteristicResponses\n        id\n      }\n    }\n  }\n  ...FormItemCharacteristicResponses_characteristic\n}\n\nfragment PortalProfileComplete_panelist on PanelistNode {\n  customPanelistPortal {\n    contactEmail\n    customColor\n    fadeBgBottom\n    faviconUrl\n    footerImageUrl\n    headerMarkup\n    headerMarkupEnabled\n    heroAssetUrl\n    heroBackgroundUrl\n    hidePanelistProfile\n    pageTitle\n    privacyPolicyUrl\n    termsLabel\n    termsUrl\n    id\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "6f7346ee3ccd8519d07dc5eda9439b3b";

export default node;
